import * as React from 'react'
import { Autocomplete, GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { FieldFooter, ToggleFormField } from 'traveldesk-ui';

const containerStyle = {
    width: '100%',
    height: '400px'
};
interface Props {
    label: string
    placeIdLabel: string
    value?: string
    validationError?: string
    onChange: (placeId: string | undefined) => void
    onInvalidUrl: (message: string) => void
    onRefreshRating: () => void
}

interface TripAdvisorUrlResult {
    locationId?: string
    error?: string
}

function getLocationIdFromUrl(url: string): TripAdvisorUrlResult {
    if (/\/AttractionProductReview-/i.test(url)) {
        return {
            error: "Tripadvisor product/experience URLs are not supported. Paste the operator's Attraction_Review, Hotel_Review, or Restaurant_Review page URL instead."
        }
    }

    var regex = /d(\d+)-/;
    var match = url.match(regex);

    if (match && match.length > 1) {
        return { locationId: match[1] };
    }

    return {
        error: "Couldn't find a Tripadvisor location ID in this URL."
    };
}

const TripAdvisorLocationIdPicker = (props: Props) => {

    const [isLoading, setIsLoading] = React.useState<boolean>(false)
    const [isTripAdvisorId, setIsTripAdvisorId] = React.useState<boolean>(props.value ? true : false)

    const onChange = (e: React.ChangeEvent<HTMLInputElement> | undefined) => {
        setIsLoading(true)
        const url = e?.target.value ?? ""
        if (!url) {
            props.onChange(undefined)
            setIsLoading(false)
            return
        }

        const result = getLocationIdFromUrl(url)
        if (result.error) {
            props.onInvalidUrl(result.error)
        } else {
            props.onChange(result.locationId)
        }
        setIsLoading(false)
    }
    const onDropLocation = () => {
        onChange(undefined)
    }


    const onCheckIsTripAdvisorId = () => {
        if (isTripAdvisorId) onChange(undefined)
        setIsTripAdvisorId(!isTripAdvisorId)
    }
    return <>
        <br />
        <ToggleFormField
            label={props.label}
            name="IsGooglePlaceId"
            value={isTripAdvisorId}
            onChange={onCheckIsTripAdvisorId}

        />

        {isTripAdvisorId ? <React.Fragment>

            <span>{props.placeIdLabel}</span>
            <i style={{ marginLeft: '10px' }} className='fa fa-refresh clickable' onClick={() => props.onRefreshRating()} />
            <FieldFooter error={props.validationError} />

            <br />
            <br />
            <input
                type="text"
                placeholder="Copy/paste trip advisor url here"
                value={props.value || ''}
                onChange={onChange}
            />
            <br />
        </React.Fragment>
            : null}
        {isTripAdvisorId && <label className="clickable" onClick={onDropLocation}>Clear place Id</label>}

    </>
}
export default React.memo(TripAdvisorLocationIdPicker)
